<template>
  <div>

    <portlet
            :actionsBlock="true"
            :icon="'fad fa-project-diagram'"
            :title="'Tabel configuratie start stop'"
    >
      <template slot="actionsBlock">
        <div class="col">
          <button class="btn btn-primary" @click="addNewColumn()">Add config</button>
        </div>
        <div class="col">
          <button class="btn btn-success col-12" @click="saveConfig">save</button>
        </div>

      </template>
      <template slot="portletBody">
        <div class="row" v-if="selectedCompanyConfig && selectedCompanyConfig.config">
          <template v-for="(conf,idx) in selectedCompanyConfig.config.startStop.tableConfig">
            <div class="col">
              <div class="form-group">
                <label>Filterable</label>
                <div class="custom-control custom-checkbox">
                  <input v-model="conf.filterable"
                         :value="conf.filterable"
                         type="checkbox"
                         :id="'filterable-'+idx"
                         class="custom-control-input"
                  />
                  <label class="custom-control-label" :for="'filterable-'+idx">
                    <span>{{conf.filterable}}</span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label for="key">keys</label>
                <input type="text" v-model="conf.key" class="form-control" id="key"
                       aria-describedby="emailHelp">
              </div>
              <div class="form-group">
                <label for="Label">Label</label>
                <input type="text" v-model="conf.label" class="form-control" id="Label"
                       aria-describedby="Label" placeholder="Enter Label">
              </div>
              <div class="form-group">
                <label>Orderable</label>
                <div class="custom-control custom-checkbox">
                  <input v-model="conf.orderable"
                         :value="conf.orderable"
                         type="checkbox"
                         :id="'orderable-'+idx"
                         class="custom-control-input"
                  />
                  <label class="custom-control-label" :for="'orderable-'+idx">
                    <span>{{conf.orderable}}</span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label>Searchable</label>
                <div class="custom-control custom-checkbox">
                  <input v-model="conf.searchable"
                         :value="conf.searchable"
                         type="checkbox"
                         :id="'searchable-'+idx"
                         class="custom-control-input"
                  />
                  <label class="custom-control-label" :for="'searchable-'+idx">
                    <span>{{conf.searchable}}</span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label>Visible</label>
                <div class="custom-control custom-checkbox">
                  <input v-model="conf.visible"
                         :value="conf.visible"
                         type="checkbox"
                         :id="'visible-'+idx"
                         class="custom-control-input"
                  />
                  <label class="custom-control-label" :for="'visible-'+idx">
                    <span>{{conf.visible}}</span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label>Responsive Priority</label>
                <p>Note: The lower the number, the more priority it gets. Activity and workflow are set to 10, progress
                  bar and button are set to 0</p>
                <input v-model.number="conf.responsivePriority"
                       type="text"
                       :id="'responsive-'+idx"
                       class="form-control"
                />
              </div>
              <div class="form-group">
                <label for="type">Type</label>
                <select v-model="conf.type" class="form-control ">
                  <option value="string">String</option>
                  <option value="date">Date</option>
                  <option value="milliseconds">Milliseconds</option>
                </select>

                <div class="form-group">
                  <label for="Label">Date formatting</label>
                  <input type="text" v-model="conf.format" class="form-control" id="format"
                         aria-describedby="Label" placeholder="Enter format">
                </div>
              </div>
              <button class="btn btn-danger col-12" @click="deleteColumn(idx)"> Delete this column</button>


            </div>
          </template>

        </div>

      </template>

    </portlet>
  </div>
</template>


<script>

  import {mapGetters} from 'vuex';


  const TABLE_CONFIG = {
    filterable: true,
    key: 'uid',
    label: 'Reference',
    orderable: true,
    searchable: true,
    type: 'string',
    responsivePriority: 10,
    visible: true,
    format: 'DD/MM/YY'
  };
  //@vuese
  //@group #ROOT
  export default {
    name: 'CompanyConfig',
    components: {},
    mixins: [],
    props: ['selectedCompany'],
    data() {
      return {
        companies: [],
        selectedCompanyConfig: null,
        companyConfig: {}
      };
    },
    firestore() {
      return {
        selectedCompanyConfig: this.$FB.collection('companies').doc(this.selectedCompany),
        companies: this.claims.root ? this.$FB.collection('companies') : this.$FB.collection('companies').doc(this.claims.companyId)
      };
    },
    methods: {
      // @vuese
      // This updates the company config for the startstop table
      // currently supported data
      // `{  filterable: true,key: 'uid', label: 'Reference', orderable: true, searchable: true,   type: 'string',  responsivePriority: 10, visible: true,format: 'DD/MM/YY'};`
      saveConfig() {

        this.$FB.collection('companies').doc(this.selectedCompany).update(this.selectedCompanyConfig).then(() => {
          return this.$swal({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000,
            icon: 'success',
            title: 'updated'
          });
        }).catch(e => {
          return this.$swal({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000,
            icon: 'warning',
            title: 'sum ting wong'
          });
        });
      },
      // @vuese
      // Add new column for selected company
      addNewColumn() {
        this.selectedCompanyConfig.config.startStop.tableConfig.push(TABLE_CONFIG);
      },
      // @vuese
      // remove column (still needs to be saved )
      deleteColumn(idx) {
        this.selectedCompanyConfig.config.startStop.tableConfig.splice(idx, 1);
      }
    },
    computed: {
      ...mapGetters('users', [
        'getMe'
      ]),
      //@vuese
      // Get user claims
      claims() {
        return this.$FirebaseAuth.getClaims();
      }

    },
    watch: {
      selectedCompanyConfig() {
        let keysNeeded = Object.keys(TABLE_CONFIG);
        _.each(this.selectedCompanyConfig.config.startStop.tableConfig, conf => {
          _.each(keysNeeded, key => {
            let exists = _.has(conf, key);
            if(!exists) {
              conf[key] = TABLE_CONFIG[key];
            }
          });
        });
      }
    },
    created() {

    }
  };
</script>
<style lang="scss">

</style>
